"use client"

import { ArrowUpIcon } from "lucide-react"
import { useEffect, useState } from "react"

/**
 * Back-to-top FAB shown in the footer once the diner has scrolled past a
 * viewport. Client-only (needs `window` scroll state); respects
 * `prefers-reduced-motion` by jumping instead of smooth-scrolling. Colour comes
 * from the tenant `--primary` token, so it matches each tenant's hue.
 */
export function ScrollToTop({ label }: { label: string }) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight)
    onScroll()
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  const toTop = () => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" })
  }

  return (
    <button
      type="button"
      onClick={toTop}
      aria-label={label}
      data-visible={visible}
      className="fixed end-6 bottom-6 z-40 grid size-12 place-items-center rounded-4xl bg-primary text-primary-foreground shadow-lg transition-all duration-200 hover:-translate-y-0.5 data-[visible=false]:pointer-events-none data-[visible=false]:translate-y-2 data-[visible=false]:opacity-0"
    >
      <ArrowUpIcon className="size-5" aria-hidden />
    </button>
  )
}
